"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _SegmentListSuperSegments = _interopRequireDefault(require("../containers/SegmentListSuperSegments"));

var _SegmentListAll = _interopRequireDefault(require("../containers/SegmentListAll"));

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SegmentList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SegmentList, _React$Component);

  function SegmentList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "renderPersonaList", function (superSegments, key) {
      var _this$props = _this.props,
          handleCheckBoxAction = _this$props.handleCheckBoxAction,
          expanded = _this$props.expanded,
          isDataPage = _this$props.isDataPage,
          audienceView = _this$props.audienceView,
          fixedAudienceView = _this$props.fixedAudienceView;
      var shouldDisplaySuperSegments;

      if (fixedAudienceView === 'communities') {
        // Show SuperSegments if you've forced the SuperSegments view
        shouldDisplaySuperSegments = true;
      } else if (fixedAudienceView === 'personas') {
        // Don't show SuperSegments if you've forced the Segments view
        shouldDisplaySuperSegments = false;
      } else if (isDataPage && audienceView === 'communities') {
        // Show the SuperSegments view if that view is selected, and this is a DataPage
        shouldDisplaySuperSegments = true;
      } else {
        // Default to false
        shouldDisplaySuperSegments = false;
      }

      if (shouldDisplaySuperSegments) {
        return /*#__PURE__*/React.createElement(_SegmentListSuperSegments["default"], {
          superSegment: superSegments,
          key: key,
          handleCheckBoxAction: handleCheckBoxAction
        });
      } else {
        return /*#__PURE__*/React.createElement(_SegmentListAll["default"], {
          expanded: expanded,
          superSegment: superSegments,
          key: key,
          handleCheckBoxAction: handleCheckBoxAction
        });
      }
    });

    return _this;
  }

  var _proto = SegmentList.prototype;

  _proto.render = function render() {
    var superSegments = this.props.superSegments;
    return /*#__PURE__*/React.createElement("ul", {
      className: "persona-list"
    }, superSegments && Object.values(superSegments).map(this.renderPersonaList));
  };

  return SegmentList;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    superSegments: state.superSegments.bySlug,
    // TODO: Finish off changing to superSegments
    audienceView: state.audienceView.view.value,
    isDataPage: state.options.isDataPage.value
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, undefined)(SegmentList); // export default SegmentList;


exports["default"] = _default;